export default __webpack_public_path__ + "static/media/2403.40e7ab29.png";